import { render, staticRenderFns } from "./cModalTechnicalLaboratorio.vue?vue&type=template&id=69448d49&lang=es"
import script from "./cModalTechnicalLaboratorio.vue?vue&type=script&lang=js"
export * from "./cModalTechnicalLaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports